<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_buy">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <!-- <UserLeftMenu :active_menu_index="4" /> -->
        <div class="current_title">学贝余额</div>
        <div class="right_content">
          <!--学币余额-->
          <div class="balance">
            <div class="balance_info">1元=1学贝，学贝可用于购买鲸贝英语官网内的所有产品</div>
            <div class="balance_total">
              <span>{{user_info.coins}}</span>学贝
            </div>
          </div>
          <p class="current_title titlefix">学贝充值</p>
          <div class="pay_area">

            <div
              class="pay_item"
              @click="choose_pay(item.id,item.price)"
              v-for="(item,index) of listData"
              :key="index"
              :style="(index) == 0 ?'margin-left:65px;':''"
              :class="item.id == pay_item?'pay_item_active':''"
            >
              <div class="pay_detail">
                <p class="cost">
                  <span class="money">￥{{item.price}}</span>
                </p>
                <p class="add">到账：{{user_info&&user_info.vip_payment_count===0&&user_info.type==2?item.price*2:item.coins}}学贝</p>
              </div>
              <div class="active_bg" v-if="item.id == pay_item">
                <img src="../../assets/image/common/new/select.png" />
              </div>
              <div class="first_pay" v-if="user_info&&user_info.vip_payment_count===0&&user_info.type==2&&false">首充翻倍</div>
            </div>
            <p class="settle_title">
              <span class="title_text">选择支付方式付款</span>
              应付金额
              <span class="money_num">{{now_price}}</span>
              <span class="red">元</span>
              <span class="icon">
                <img src="../../assets/image/user_center/choose.png" alt class="pic_full" />
              </span>
              《VIP会员服务协议》
            </p>
            <div class="pay_way">
              <div class="pay_way_item hand_point" @click="change_way(0)">
                <span class="active_icon" v-if="pay_type == 0">
                  <img src="../../assets/image/user_center/btn_hover (2).png" alt class="pic_full" />
                </span>
                <span class="active_icon" v-if="pay_type != 0">
                  <img src="../../assets/image/user_center/pay_no_select.png" alt class="pic_full" />
                </span>
                <span class="pay_way_icon">
                  <img src="../../assets/image/user_center/ali_pay.png" alt class="pic_full" />
                </span>
                <span class="pay_way_text">支付宝</span>
                <span class="fr">
                  <span class="total_text">应付金额：</span>
                  <span class="total_money">{{now_price}}</span>
                  <span class="yuan">元</span>
                </span>
              </div>
              <div class="divider"></div>
              <div class="pay_way_item hand_point" @click="change_way(1)">
                <span class="active_icon" v-if="pay_type == 1">
                  <img src="../../assets/image/user_center/btn_hover (2).png" alt class="pic_full" />
                </span>
                <span class="active_icon" v-if="pay_type != 1">
                  <img src="../../assets/image/user_center/pay_no_select.png" alt class="pic_full" />
                </span>
                <span class="pay_way_icon">
                  <img src="../../assets/image/user_center/wehcat_pay.png" alt class="pic_full" />
                </span>
                <span class="pay_way_text">微信</span>
                <span class="fr">
                  <span class="total_text">应付金额：</span>
                  <span class="total_money">{{now_price}}</span>
                  <span class="yuan">元</span>
                </span>
              </div>
              <div class="clear"></div>
            </div>
            <button class="pay_btn hand_point" @click="pay" v-if="!is_paying">去支付</button>
            <button class="pay_btn" disabled v-if="is_paying">
              <i class="el-icon-loading" style="margin-right:10px"></i>去支付
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottombox">
      <commonbottom />
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    commonbottom
  },
  data: function() {
    return {
      pay_item: "",
      pay_type: 0, //0支付宝,1微信
      listData: "",
      now_price: "",
      user_info: "",
      is_paying: false,
      isvip: false
    };
  },
  mounted: function() {
    this.getList();
    this.get_info();
  },
  beforeDestroy() {
    this.is_paying = false;
  },
  methods: {
    choose_pay(type, price) {
      this.pay_item = type;
      this.now_price = price;
    },
    change_way(way) {
      this.pay_type = way;
    },
    getList() {
      //获取列表
      let self = this;
      common.requestFun(self, "get", "/vip/price", {}, res => {
        if (res.data.code == 200) {
          self.listData = res.data.data;
          if (self.$route.query.id) {
            self.pay_item = self.$route.query.id;
            for (let item of res.data.data) {
              if (item.id == self.$route.query.id) {
                self.now_price = item.price;
              }
            }
          } else {
            self.pay_item = self.listData[2].id;
            self.now_price = self.listData[2].price;
          }
        }
      });
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
          self.isvip = self.user_info.type ===3||self.user_info.type ===4||self.user_info.type ===5||self.user_info.type ===6;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    pay() {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/vip/charge",
        {
          id: self.pay_item
        },
        res => {
          if (res.data.code == 200) {
            self.is_paying = true;
            //pay_type 0支付宝,1微信
            if (self.pay_type == 0) {
              let redirectURL = encodeURIComponent("/#/user-center-order");
              if (res.data.data.order_id) {
                window.location.href = `https://gemsbaby.com/payment/alipay?order_id=${res.data.data.order_id}&redirectURL=${redirectURL}`;
              }
            }
            if (self.pay_type == 1) {
              if (res.data.data.order_id) {
                self.$router.push(`./wxpay?order_id=${res.data.data.order_id}&price=${self.now_price}`);
              }
            }
          } else {
            self.is_paying = false;
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    }
  }
};
</script>
<style scoped src="./user_center_buy.css"></style>
